/** GDPR veri öznesi tanımlayıcısı — anonimleştirmede yenilenir */
export const SUBJECT_ID_KEY = 'luminary_subject_id';

/** Eski çerez onay anahtarı (geriye dönük uyumluluk) */
export const LEGACY_CONSENT_KEY = 'luminary_cookie_consent';

export const PRIVACY_API_URL = import.meta.env.VITE_PRIVACY_API_URL as string | undefined;
